/**
 * Rebuilds <option> children of a <select>, restoring the desired value when possible.
 * If desiredValue is not in the new options, resets to '' (empty/placeholder).
 * Returns true if the value was lost (so callers can fire onChange).
 *
 * @param {HTMLSelectElement} select
 * @param {import('../../contracts/forms.js').FieldOption[]} options
 * @param {string} placeholder
 * @param {string} desiredValue - The value to restore (from local state, NOT from select.value).
 * @returns {boolean} Whether the desired value was lost (true = value changed to '').
 */
export function rebuildSelectOptions(select, options, placeholder, desiredValue) {
  // Clear existing options
  select.textContent = '';

  // Add placeholder
  const placeholderOpt = document.createElement('option');
  placeholderOpt.value = '';
  placeholderOpt.textContent = placeholder;
  select.appendChild(placeholderOpt);

  // Add options
  for (const opt of options) {
    const optEl = document.createElement('option');
    optEl.value = opt.value;
    optEl.textContent = opt.label;
    select.appendChild(optEl);
  }

  // Restore value
  const valueExists = options.some(opt => opt.value === desiredValue);
  select.value = valueExists ? desiredValue : '';

  // Return true only when a real value was lost
  return desiredValue !== '' && !valueExists;
}
